import React from 'react'
import Column from '@amzn/meridian/column'
import { IndividualNotificationItem } from './IndividualNotificationItem'
import { IIndividualNotificationGroupProps } from '../types'
import { StoreNotificationHeader } from './StoreNotificationHeader'
import './IndividualNotificationGroup.scss'

/**
 * IndividualNotificationGroup Component
 *
 * Groups individual notifications by store with a header showing
 * store icon, name, and notification count badge.
 */
export const IndividualNotificationGroup: React.FC<IIndividualNotificationGroupProps> = ({
    storeId,
    storeName,
    toolName,
    notifications,
}) => {
    return (
        <Column spacing="300">
            <StoreNotificationHeader storeName={storeName} notificationCount={notifications.length} />
            <Column spacing="300">
                {notifications.map((notification, index) => (
                    <IndividualNotificationItem
                        key={`${storeId}-notification-${index}`}
                        toolName={toolName}
                        imageUrl={notification.imageUrl}
                        imageRotation={notification.imageRotation}
                        notificationMessage={notification.notificationMessage}
                        supplementaryMessage={notification.supplementaryMessage}
                        fixtureAddress={notification.fixtureAddress}
                        timestamp={notification.timestamp}
                        notificationAction={notification.notificationAction}
                        deepUrl={notification.deepUrl}
                    />
                ))}
            </Column>
        </Column>
    )
}
